// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarRefractedV4_navbar__GkVie","navbarCollapse":"NavbarRefractedV4_navbarCollapse__YWb4P"};